import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"

import "./index.less"
import { Checkbox, Input, Popover, Select, Switch, TreeSelect } from "antd"
import { isAmbassadorActive, LOCAL_ACTIVE_ROL, LOCAL_ISOLATED_METRICS } from "../../utils/storage"
import { Link } from "react-router-dom"
import {
  CloseOutlined,
  QuestionCircleFilled,
  SearchOutlined,
} from "@ant-design/icons"
import { get, isNaN } from "lodash"
import { generateTree } from "../../utils/utils"
import { ROLE_AMBASSADOR, WORKING_ENVIRONMENT_LABEL } from "../../utils/constants"

const { TreeNode } = TreeSelect

const { Option } = Select

export function HeaderDivision(props) {
  const { measureInfo, searchLocation } = props
  const [isAmbassadorRole] = useState(isAmbassadorActive())

  const setNameMetricsTotalLabel = () => {
    const { measureInfo } = props
    let surveyType = get(measureInfo, "id_survey_type", null)
    let hasLabel = get(measureInfo, "metric_total_label", null)
    let response = get(measureInfo, "survey_type_name", null)

    return response
  }

  const renderFilters = () => {
    const {
      checkboxExclude,
      dimensions,
      changeExcludeCheckbox,
      measureInfo,
      searchLocation,
      isEngagement,
      isEngagementOnly,
      selectedType,
      onChangeType,
      selectedDimension,
      searchDivision,
      onChangeSearchDivision,
      onChangeDimension,
      selectedSegment,
    } = props

    let isGeneralSegmentTab =
      !selectedSegment && get(measureInfo, "segments", []).length > 0

    let newDimensions = dimensions.filter((item) => {
      if (isEngagement && selectedType == "Engagement") {
        if (item.engagement) return item
      } else {
        if (!item.engagement) return item
      }
    })

    newDimensions = generateTree("id", "id_parent", newDimensions)

    if (
      newDimensions.length > 0 &&
      isEngagement &&
      selectedType === "Engagement"
    ) {
      newDimensions = newDimensions[0].childs
    }

    return (
      <Fragment>
        {LOCAL_ISOLATED_METRICS() == "true" && (
          <div
            style={{
              marginLeft: "auto",
              paddingRight: 10,
              height: 30,
              paddingTop: 5,
            }}>
            <Checkbox
              checked={checkboxExclude}
              onChange={(e) => changeExcludeCheckbox(e)}>
              Excluir subdivisiones
            </Checkbox>
            <Popover
              placement="top"
              content={
                <div style={{ maxWidth: 245, textAlign: "center" }}>
                  Activa el checkbox para visualizar los
                  <br />
                  resultados únicamente de las
                  <br />
                  divisiones superiores, <b>excluyendo</b> los
                  <br />
                  resultados de sus subdivisiones.
                </div>
              }>
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  marginLeft: 8,
                }}
              />
            </Popover>
          </div>
        )}
        <div>
          {isEngagement && !isEngagementOnly && (
            <Select
              placeholder="Seleccionar"
              style={{ width: 200, marginRight: 8 }}
              value={selectedType}
              onChange={(s) => onChangeType(s)}>
              {["Engagement", setNameMetricsTotalLabel()].map((item, i) => (
                <Option key={i} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          )}

          {!isGeneralSegmentTab && (
            <TreeSelect
              style={{ width: 200, marginRight: 8 }}
              allowClear
              placeholder="Seleccionar dimensión"
              showSearch
              value={selectedDimension}
              treeNodeFilterProp="title"
              onChange={(s) => onChangeDimension(s)}>
              {newDimensions.map((item) => {
                return (
                  <TreeNode
                    idSelected={item.id}
                    value={item.id}
                    title={item.name}
                    key={item.id}>
                    {item.childs &&
                      item.childs.map((child) => {
                        return (
                          <TreeNode
                            value={child.id}
                            title={child.name}
                            key={child.id}
                            idSelected={child.id}
                          />
                        )
                      })}
                  </TreeNode>
                )
              })}
            </TreeSelect>
          )}
          <Input
            value={searchDivision}
            placeholder="Buscar..."
            style={{ width: 200 }}
            onChange={(e) => onChangeSearchDivision(e.target.value)}
            suffix={
              searchDivision ? (
                <CloseOutlined
                  className="collaborators-header-search-clear"
                  type="close"
                  onClick={() => {
                    onChangeSearchDivision("")
                  }}
                />
              ) : (
                <SearchOutlined type="search" />
              )
            }
          />
        </div>
      </Fragment>
    )
  }


  const isAmbassador = LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR
  const division=isAmbassador? `?id_divisionParent=${searchLocation.id_division}` :''
  return (
    <div className="HeaderDivision">
      <div className="HeaderDivision-Link">
        <Link
          to={`/reports/measure/${measureInfo.id_survey_type}/${measureInfo.id_measure}${division}`}>
          {"<"} {measureInfo.name}
        </Link>
      </div>
      <div className="HeaderDivision-Container">
        <div className="HeaderDivision-Container-Title">
          Ranking de divisiones{" "}
          {parseInt(searchLocation.id_segment) !== 0 &&
            !isNaN(parseInt(searchLocation.id_segment)) &&
            `- ${get(measureInfo, "segment_name", "")}`}
        </div>
        <div className="HeaderDivision-Container-Filter">{renderFilters()}</div>
      </div>
    </div>
  )
}

HeaderDivision.propTypes = {
  selectedDivisionInfo: PropTypes.object,
  checkboxExclude: PropTypes.bool,
  divisionsAvailable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureInfo: PropTypes.object,
  changeDivision: PropTypes.func,
  changeExcludeCheckbox: PropTypes.func,
  searchLocation: PropTypes.object,
}

export default HeaderDivision
